import { useState } from 'react';
import languageContext from './context/languageContext';
import Browser from './components/1-Header/Browser';
import Header from './components/1-Header/Header';
import Home from './components/2-Home/Home';
import About from './components/3-About/About';
import Skills from './components/4-Skills/Skills';
import Portfolio from './components/5-Portfolio/Portfolio';
import Contact from './components/6-Contact/Contact';

function App() {

  const [theme, setTheme] = useState(true)
  const [language, setLanguage] = useState(true)

  const changeThemeApp = (boolean) => setTheme(boolean);
  const changeLanguageApp = (boolean) => setLanguage(boolean);

  return (
    <div className={theme ? 'App-light' : 'App-dark'}>
      <languageContext.Provider value={language}>
        <Header 
          changeTheme={changeThemeApp} 
          changeLanguage={changeLanguageApp} 
        />
        <Browser />
        <Home />
        <About />
        <Skills />
        <Portfolio />
        <Contact />
      </languageContext.Provider>
    </div>
  );
}

export default App;
